<template>
	<div 
    style="display: flex; flex-direction: column; height: calc(100vh - 50px); width: 100%"
  >
    <graph-sub-nodes 
      v-if="nestedItem && dataobjectId"
      :item="nestedItem" 
      :dataobject-id="dataobjectId" 
      parent-id=""
      :is-nested="false"
      @navigate="(item) => nestedItem = item"
    />
    <graph-node-detail 
      v-else-if="dataobjectId"
      :dataobject-id="dataobjectId" 
      :nodes="graph.nodes"
      :links="graph.links"
      parent-id=""
      :is-nested="false"
      @navigate="$event => dataobjectId = $event" 
      @navigateSub="$event => nestedItem = $event" 
    />
    <v-container v-else style="overflow-y: auto; flex: 1; padding-bottom: 150px">
      <graph-card 
        v-for="node in nodes" 
        :key="node.id" 
        :node="node" 
        @navigate="$event => dataobjectId = $event" 
      />
    </v-container>
  </div>
</template>

<script setup lang="ts">
import { ref, computed, defineProps, PropType } from "vue";
import type { Graph } from "@lr-notitia/notitia-operator/schemas";
import { BubblyItem } from "@lr-notitia/bubbly-d3";
import GraphCard from "./GraphCard.vue";
import GraphNodeDetail from "./GraphNodeDetail.vue";
import GraphSubNodes from "./GraphSubNodes.vue";

const compProps = defineProps({
	graph: {
		type: Object as PropType<Graph | any>,
		required: true,
		default: {},
	},
});

const dataobjectId = ref<string|undefined>(undefined)
const nestedItem = ref<BubblyItem|undefined>(undefined)

const nodes = computed(() => {
  return compProps.graph.nodes.filter(g => !g.id.includes("_suggestion"))
})
</script>